import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogSearchComponent } from './Dialogs/dialog-search/dialog.search.component';

@Injectable({ providedIn: 'root' })
export class SearchModuleService {

  dataTransmitted = new Subject<number[]>();
  private allowMultipleSelect: boolean = false;

  constructor(private router: Router, private dialog: MatDialog,) {
  }

  private checkMultipleSelect() {
    const urlsForMultipleSelect: string[] = ['/templatemanager', '/softwareupdate']
    if (urlsForMultipleSelect.includes(this.router.url)) {
      this.allowMultipleSelect = true;
    } else {
      this.allowMultipleSelect = false;
    }
  }

  openSearchDialog(): void {
    this.checkMultipleSelect();

    const dialogRef = this.dialog.open(DialogSearchComponent, {
      maxHeight: '100vh',
      data: [],
      disableClose: true
    });

    let instance = dialogRef.componentInstance;
    instance.allowMultipleSelect = this.allowMultipleSelect;

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.sendData(result)
      }
    });

  }

  private sendData(data: number[]) {
    this.dataTransmitted.next(data);
  }

}
